<template>
    <fin-step-by-step-question
      :questionIndex="questionIndex"
      :selectable="value>=0"
      :selection-hint="value>=0 ? properties.values[value].tooltip.text : 'Wähle eine Antwort um mehr darüber zu erfahren.'"
      @next="$emit('next')"
      :value="value"
      :question=properties.question
      :questionTitle=properties.title
      :class="$vuetify.breakpoint.mdAndUp ? 'question' : ''"
    >
      <div>
        <!-- && !isIPad -->
        <illu :value="value"
              :animations="animations"
              :tooltipTexts="properties.values"
              class="step-by-step-illus"
              @input="val => this.$emit('input', val)"
              v-if="$vuetify.breakpoint.mdAndUp "/>
        <fin-step-by-step-carousel-answers v-else
                                           :animations="animations"
                                           :value="value"
                                           :answers="properties.values"
                                           @input="val => {this.$emit('input', val), this.$emit('next')}"
        />
      </div>
    </fin-step-by-step-question>
</template>

<script>
import FinStepByStepQuestion from '@/components/pages/onboarding/Step2/StepByStep/StepByStepQuestion/index'
import Illu from './Illu'
import FinStepByStepCarouselAnswers from "../Carousel/StepByStepCarouselAnswers"

//import finBrowser from '@/js/finBrowser'

export default {
  name: 'FinStepByStep1',
  components: {
    FinStepByStepCarouselAnswers,
    Illu,
    FinStepByStepQuestion
  },
  data() {
    return {
      selection: -1,
//          isIPad: finBrowser.IS_IPAD
    }
    },
  props: {
    value: {
        type: Number
    },
      questionIndex: {
          type: Number
    },
    properties: {
      type: Object
    },
      animations: {
          type: Array
      }
  }
}
</script>

<style scoped lang="scss">
  .question {
    background: linear-gradient(to bottom, transparent 50%, #F0E8DD 0%);
  }
</style>
